(ns scittle.asami
  {:no-doc true}
  (:require [scittle.core :as scittle]
            [sci.core :as sci]
    [asami.core]
    [asami.analytics]))

;; Plugin: asami
;; Generated by build.clj

(defn init []
  (scittle/register-plugin!
   ::asami
   {:namespaces
   {'asami.core (sci/copy-ns asami.core (sci/create-ns 'asami.core nil))
    'asami.analytics (sci/copy-ns asami.analytics (sci/create-ns 'asami.analytics nil))}}
   ))
